// (function() {
//   'use strict'

//   angular.module('digestOverride', ['digestOverride', function($rootScopeProvider) {  
//     // INCREASED THE DIGEST LIMIT FROM DEFAULT (10) TO (15) TO HANDLE TREESTRUCTURE ON SITE PAGE
//     $rootScopeProvider.digestTtl(15); 
//   }]);
// })();

angular.module('digestOverride', [])
  .config(['$rootScopeProvider', function($rootScopeProvider) {
    // INCREASED THE DIGEST LIMIT FROM DEFAULT (10) TO (15) TO HANDLE TREESTRUCTURE ON SITE PAGE
    $rootScopeProvider.digestTtl(15);
  }]);